import PwaInstallPrompt from "./pwa-install-prompt";

export default PwaInstallPrompt;
